import { H4 } from "../typography/H4";

export const PartnerBuisinessGuideHeader = () => {
  return (
    <div className="pt-[16px] pb-[22px]">
      <H4 className="text-semantic-text-heading">비즈니스 가이드</H4>
      <div />
    </div>
  );
};
